import styled from 'styled-components';

const FormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default {
  FormInputsContainer,
};
